import { z } from "zod";
export const addressRequestChannelSchema = z.enum(["email", "sms"]);
export const sendAddressRequestBodySchema = z.union([
    z.object({
        channel: addressRequestChannelSchema,
        contactId: z.string(),
    }),
    z.object({
        channel: addressRequestChannelSchema,
        listId: z.string(),
    }),
]);
export const addressRequestSchema = z.object({
    id: z.string(),
    contactId: z.string(),
    shareLinkId: z.string(),
    channel: addressRequestChannelSchema,
    sentAt: z.string().nullable(),
    deliveredAt: z.string().nullable(),
    answeredAt: z.string().nullable(),
    deliveryStatus: z.string().nullable(),
});
//# sourceMappingURL=addressRequest.js.map